<!--
 * @Author       : Bruce
 * @Date         : 2025-03-20 17:55:27
 * @LastEditors  : Bruce
 * @LastEditTime : 2025-10-31 19:14:37
 * @FilePath     : /app/javascript/dashboard/components/widgets/ChannelItem.vue
 * @Description  :
 * Copyright 2025 Bruce, All Rights Reserved.
 * 2025-03-20 17:55:27
-->
<script>
import ChannelSelector from '../ChannelSelector.vue';
export default {
  components: { ChannelSelector },
  props: {
    channel: {
      type: Object,
      required: true,
    },
    enabledFeatures: {
      type: Object,
      required: true,
    },
  },
  emits: ['channelItemClick'],
  computed: {
    hasFbConfigured() {
      return window.chatwootConfig?.fbAppId;
    },
    // 定义不可点击的渠道列表
    disabledChannels() {
      return ['whatsapp', 'sms', 'api', 'line'];
      // return [];
    },
    isActive() {
      const { key } = this.channel;

      if (Object.keys(this.enabledFeatures).length === 0) {
        return false;
      }

      // 如果在禁用列表中，直接返回 false
      if (this.disabledChannels.includes(key)) {
        return false;
      }

      if (key === 'website') {
        return this.enabledFeatures.channel_website;
      }
      if (key === 'facebook') {
        return this.enabledFeatures.channel_facebook && this.hasFbConfigured;
      }
      if (key === 'email') {
        return this.enabledFeatures.channel_email;
      }

      return [
        'website',
        'twilio',
        'api',
        'whatsapp',
        'sms',
        'telegram',
        'line',
      ].includes(key);
    },
  },
  methods: {
    getChannelThumbnail() {
      if (this.channel.key === 'api' && this.channel.thumbnail) {
        return this.channel.thumbnail;
      }
      return `/assets/images/dashboard/channels/${this.channel.key}.png`;
    },
    onItemClick() {
      if (this.isActive) {
        this.$emit('channelItemClick', this.channel.key);
      }
    },
  },
};
</script>

<template>
  <ChannelSelector
    :class="{ inactive: !isActive }"
    :title="channel.name"
    :src="getChannelThumbnail()"
    @click="onItemClick"
  />
</template>
